import { supportServiceConnectClient } from "api";

import {
  GetUserNavigationSettingsRequest,
  GetUserNavigationSettingsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

type GetUserNavigationSettingsParams = {
  userId: string;
  orgId: string;
};

export const getUserNavigationSettings = async (
  { userId, orgId }: GetUserNavigationSettingsParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetUserNavigationSettingsResponse> => {
  const req = new GetUserNavigationSettingsRequest({
    userId: toUUID(userId),
    orgId: toUUID(orgId),
  });

  return supportServiceConnectClient.getUserNavigationSettings(req, {
    headers,
  });
};
